import React, { Component } from "react";
import {
  Button,
  Grid,
  Typography,
  WithStyles,
  withStyles,
} from "@material-ui/core";
import { MyPATDialog } from "../../../common/index";
import { userStyles } from "./style";
import {
  CloseOutlined as CloseIcon,
} from '@material-ui/icons';

interface SaveAndProceedProps extends WithStyles<typeof userStyles> {
  showPopupDialog: boolean;
  isEditMode: boolean;
  handleRedirectFunction?: Function;
  onDialogClose:Function
  classes: any;
}
class EditLockedInfoPopUp extends Component<SaveAndProceedProps> {
  constructor(props: SaveAndProceedProps) {
    super(props);
  }

  renderSaveAndExitPopUp = () => {
    const { showPopupDialog, classes,isEditMode,handleRedirectFunction,onDialogClose} = this.props;

    return (
      <>
        {!isEditMode? 
         <MyPATDialog
          dialogOpen={showPopupDialog}
          dialogHasActions={true}
          isAlignCenter={true}
          onDialogClose={onDialogClose}
          customButtonVariant="withoutBorderCloseIcon"
          isCustomBackground={false}
          otherDialogProps={{
            fullWidth: false,
            maxWidth: false,
          }}
          dialogHeading={false}
        >
          <Grid className={classes.closeIcon}>
          <CloseIcon onClick={()=>{onDialogClose() }} />
          </Grid>
          <Grid
            container
            direction="column"
            justify="center"
            alignItems="center"
            className={[classes.editLockedPopUp, classes.editLockedPopUp1].join(' ')}
          >
            <Grid item xs={12}>
              <img src="/assets/svg/Lock.svg" />
              <h2>Edit Process is Locked!</h2>

              <Typography>
                The course is already in publish process <br /> You can edit it
                once it is completly published
              </Typography>
            </Grid>
          </Grid>
        </MyPATDialog>:

        <MyPATDialog
          dialogOpen={showPopupDialog}
          dialogHasActions={true}
          isAlignCenter={true}
          onDialogClose
          customButtonVariant="withoutBorderCloseIcon"
          isCustomBackground={false}
          otherDialogProps={{
            fullWidth: false,
            maxWidth: false,
          }}
        >
          <Grid
            container
            direction="column"
            justify="center"
            alignItems="center"
            className={classes.editLockedPopUp}
          >
            <Grid item xs={12}>
              <img src="/assets/svg/edit-locked.svg" />
              <h2>Edit Process Locked!</h2>

              <Typography>
                You cannot make any changes in this course as it is already in <br/>
                publish process. <br/> 
                You can make changes in the updated course once
                it is published <br/> completely
              </Typography>
            </Grid>

             <Grid item xs={12}>
                <Button onClick={()=>{
                        handleRedirectFunction && handleRedirectFunction()
                     }}>Go to Course Listing</Button>
            </Grid>
          </Grid>
        </MyPATDialog>}
      </>
    );
  };

  render = () => {
    return this.renderSaveAndExitPopUp();
  };
}
// @ts-ignore
export default withStyles(userStyles)(EditLockedInfoPopUp);
